import { render } from "./CreateProfile.vue?vue&type=template&id=773ca955&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"

import "./CreateProfile.vue?vue&type=style&index=0&id=773ca955&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773ca955"]])

export default __exports__